//Creating featureplan static array

export let newFeatureDetails: Array<any> = [];
newFeatureDetails[0] = ["Forever Free", "Free updates", "Up to 2 users per account", "Upto 1000 invoices per month"]

newFeatureDetails[1] = ["Free updates", "Up to 4 users per account", "Unlimited invoices per month", "Premium features available", "8x5 on-call support"]

newFeatureDetails[2] = ["Free updates", "Up to 4 users per account", "Unlimited invoices per month", "Premium features available", "24x7 on-call support"]

//console.log(newFeatureDetails)
//End of static plan feature array

//Plan price static array
export let planPrice: Array<any> = [];
planPrice[0] = "0/-";
planPrice[1] = "Call us";
planPrice[2] = "Call us";

//Plan price description array

export let planPriceDesc: Array<any> = [];
planPriceDesc[0] = "per month.\n\n";
planPriceDesc[1] = "for price";
planPriceDesc[2] = "for price";